import "core-js/modules/es6.string.trim";
import { _ as __rest, a as __assign } from '../tslib.es6-9c588127.js';
import React from 'react';

var Typography = function Typography(_a) {
  var _b = _a.size,
      size = _b === void 0 ? 'p' : _b,
      elem = _a.elem,
      children = _a.children,
      _c = _a.className,
      className = _c === void 0 ? '' : _c,
      _d = _a.color,
      color = _d === void 0 ? 'foreground' : _d,
      rest = __rest(_a, ["size", "elem", "children", "className", "color"]);

  var computedElem = size !== 'small' && size !== 'fineprint' ? size : 'p';
  var Elem = !elem ? computedElem : elem;
  return React.createElement(Elem, __assign({
    className: (size + " customTypography " + color + " " + className).trim()
  }, rest), children);
};

export { Typography };